module.exports = __webpack_public_path__ + "static/paleosite_morphing3-49e594a3a6daff01b5489617efa12b9b.png";